import React, { useState, useEffect } from "react";
// import { Carousel } from "antd";
import { Carousel } from "react-responsive-carousel";

// Styles
import { Item, SelectionWrapper, Selection, Wrapper } from "./styles";

// Hooks
import useArticles from "../../hooks/useArticles";

// Assets
// Get SVGS to show in selection article
import Cylinder from "../../assets/svgs/cylinder";
//import Triangle from "../../assets/svgs/triangle";
import Tube from "../../assets/svgs/tube";
import Torus from "../../assets/svgs/torus";
import Rectangle from "../../assets/svgs/rectangle";
import Rhomboid from "../../assets/svgs/rhomboid";

//If fail charge of articles types from database, cylinder is selected
const CarouselFigures = ({ defaultValue = "cylinder", onChange }) => {
  //Selected figure
  const [currentSlide, setCurrentSlide] = useState(0);

  //Figures index
  const [figuresKey, setFiguresKey] = useState(null);
  const [figuresType, setFiguresType] = useState(null);

  //Get
  const { articleTypes } = useArticles();

  const figureIndex = (type) => {
    //const index = { cylinder: 0, torus: 1, rectangle: 2, rhomboid: 3 };
    return figuresKey && figuresKey[type] ? figuresKey[type] : 1;
  };

  useEffect(() => {
    //Get articles types from db
    async function setArticlesType() {
      const response = await articleTypes();
      if (response) {
        let objFigures = {};
        response.forEach((el) => {
          objFigures[el.name.toLowerCase()] = el.id_article_type - 1; //Carrusel render start in 0
        });
        setFiguresKey(objFigures);
        setFiguresType(response);
        setCurrentSlide(objFigures[defaultValue]);
      }
    }
    setArticlesType();
  }, []);

  //Set current figure (on edit one article default select can be diferent form cylinder)
  useEffect(() => {
    setCurrentSlide(figureIndex(defaultValue));
  }, [defaultValue]);

  //Render selection figures
  const RenderItem = ({ item, children, itemName }) => {
    const handleClick = () => {
      setCurrentSlide(item);
      onChange(itemName);
    };
    return (
      <Selection onClick={handleClick} isSelected={currentSlide === item}>
        {children}
      </Selection>
    );
  };

  return (
    <Wrapper>
      <Carousel
        showArrows={false}
        showIndicators={false}
        showThumbs={false}
        showStatus={false}
        width={"100%"}
        selectedItem={currentSlide}
        onChange={setCurrentSlide}
      >
        {figuresType &&
          figuresType.map((fig, i) => {
            return (
              <Item key={"selected-figure-item-" + i}>
                {fig.name.toLowerCase() === "cylinder" ? (
                  <Cylinder size={150} />
                ) : fig.name.toLowerCase() === "torus" ? (
                  <Torus size={150} />
                ) : fig.name.toLowerCase() === "rectangle" ? (
                  <Rectangle size={120} />
                ) : fig.name.toLowerCase() === "rhomboid" ? (
                  <Rhomboid size={120} />
                ) : fig.name.toLowerCase() === "tube" ? (
                  <Tube size={120} />
                ) : null}
              </Item>
            );
          })}
      </Carousel>
      <SelectionWrapper>
        {figuresType &&
          figuresType.map((fig, i) => {
            return (
              <RenderItem key={"figure-item-" + i} item={fig.id_article_type - 1} itemName={fig.name.toLowerCase()}>
                {fig.name.toLowerCase() === "cylinder" ? (
                  <Cylinder size={20} />
                ) : fig.name.toLowerCase() === "torus" ? (
                  <Torus size={20} />
                ) : fig.name.toLowerCase() === "rectangle" ? (
                  <Rectangle size={17} />
                ) : fig.name.toLowerCase() === "rhomboid" ? (
                  <Rhomboid size={17} />
                ) : fig.name.toLowerCase() === "tube" ? (
                  <Tube size={17} />
                ) : null}
              </RenderItem>
            );
          })}
      </SelectionWrapper>
    </Wrapper>
  );
};
export default CarouselFigures;
